import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Videos } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class VideosModule extends VuexModule {
    @Action
    [Videos.showVideos](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/videos/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Videos.listVideos](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/videos/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Videos.saveVideos](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/videos/insert`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Videos.updateVideos](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/videos/update`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Videos.deleteVideos](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/videos/delete`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}